import React from "react";

export const ComboShareComboPopupLazyComponent = React.lazy(() =>
  import(
    "features/PaymentLinks/modules/ComboShareLinkModal/ComboShareLinkModal"
  ).then((module) => ({
    default: module.ComboShareLinkModal,
  }))
);
